import { render, staticRenderFns } from "./TabsPanel.vue?vue&type=template&id=b815613e&scoped=true"
import script from "./TabsPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./TabsPanel.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b815613e",
  null
  
)

export default component.exports